// Module
var code = "<abx-app-header abx-primary-text=\"Admin\" abx-on-group-change=\"vm.onGroupSelect($event)\" abx-on-building-change=\"vm.onBuildingSelect($event)\" abx-is-open=\"false\" abx-locked-open=\"false\"> </abx-app-header> <div id=\"content\" flex layout=\"column\" style=\"margin:0\" ui-view ng-cloak></div> ";
// Exports
module.exports = code;